import { useState } from 'react'
import { Card, Form, Input, Button, message, Typography } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useAuthStore } from '../store/auth'
import { adminLogin } from '../api/admin'

const { Title } = Typography

const Login = () => {
  const { setAuth } = useAuthStore()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (values: { email: string; password: string }) => {
    setLoading(true)
    try {
      const response = await adminLogin(values.email, values.password)
      console.log('Login response:', response.data)
      
      if (!response.data.success) {
        message.error(response.data.error || '登录失败')
        return
      }
      
      const { token, account } = response.data.data
      if (!token || !account) {
        message.error('登录响应数据不完整')
        console.error('Invalid response data:', response.data)
        return
      }
      
      // 先保存到 localStorage，确保状态持久化
      localStorage.setItem('kaying-auth-storage', JSON.stringify({
        state: { token, account },
        version: 0
      }))
      
      setAuth(token, account)
      message.success('登录成功')
      
      // 强制页面刷新以确保状态更新
      window.location.href = '/'
    } catch (error: any) {
      console.error('Login error:', error)
      message.error(error.response?.data?.error || error.message || '登录失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#f0f2f5',
    }}>
      <Card style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
            咖影AI存储平台
          </Title>
          <p style={{ color: '#666', marginTop: 8 }}>管理后台登录</p>
        </div>
        <Form
          name="login"
          onFinish={handleSubmit}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: '请输入邮箱' },
              { type: 'email', message: '请输入有效的邮箱地址' },
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="管理员邮箱" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              登录
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center', color: '#999', fontSize: 12 }}>
          默认管理员: admin@kaying.ai / admin123
        </div>
      </Card>
    </div>
  )
}

export default Login
